import { useEffect, useState } from 'react';
import QRCode from 'qrcode';

const QR_SIZE = 232;

/** A link or pairing code drawn as a QR, in Dale's café ink on paper. */
export function QrCode({
  value,
  alt = 'Código QR para vincular el WhatsApp del negocio',
}: {
  value: string;
  alt?: string;
}) {
  const [src, setSrc] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let alive = true;
    QRCode.toDataURL(value, { width: QR_SIZE, margin: 1, color: { dark: '#22190f', light: '#fffdf9' } })
      .then((url) => alive && setSrc(url))
      .catch(() => alive && setFailed(true));
    return () => {
      alive = false;
    };
  }, [value]);
  if (failed) return <p className="row-sub">No pudimos dibujar el código. Pide uno nuevo.</p>;
  if (!src) return <div className="reception-qr reception-qr-loading" aria-hidden="true" />;
  return <img className="reception-qr" src={src} width={QR_SIZE} height={QR_SIZE} alt={alt} />;
}
